import { UploadOutlined } from "@ant-design/icons";
import { Avatar, Button, Col, Divider, Row, Upload } from "antd";
import TextArea from "antd/es/input/TextArea";
import React from "react";

const Inspections = () => {
  return (
    <div>
      <div className="emptyPage">
        <p>There is nothing here.</p>

        <Row justify="end" gutter={16}>
          <Col>
            <Button>Next</Button>
          </Col>
        </Row>

        <Divider />

        <Row>
          <Col span={2}>
            <Avatar>KA</Avatar>
          </Col>
          <Col span={22}>
            <TextArea
              style={{
                height: 200,
                resize: "none",
              }}
              placeholder="Write a comment… Type @ to mention other users."
            />
          </Col>
        </Row>
        <Row justify="end" gutter={16}>
          <Col>
            <Upload>
              <Button style={{ marginTop: "10px" }}>
                <UploadOutlined />
              </Button>
            </Upload>
          </Col>
          <Col>
            <Button style={{ marginTop: "10px" }}>Send</Button>
          </Col>{" "}
        </Row>
      </div>
    </div>
  );
};

export default Inspections;
